<template>
	<div class="container-list">
		<div class="flex">
			<unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
			<div class="flex1">
				<div class="common-page common-head">
					<div class="common-page common-head-title">
						<i class="icon-tr--detailed" style="padding-right: 5px"></i>
						演练列表
					</div>
				</div>
				<div class="common-page common-body">
					<div class="common-page common-tool-bar" style="justify-content: flex-end">
						<div class="flex">
							<!-- type:  0 只查看  1 可编辑   page:0 演练 1 灭火 3预案  -->
							<div class="ml20">
								<router-link
									class="mr10"
									:to="{
										path: '/plan/plan-add',
										query: { type: 1, page: 0,c_num: cpNum },
									}"
									v-hasPermi="['plan:drillrecord:addAndUpdate']"
								>
									<el-button type="primary" icon="el-icon-plus">新增演练方案</el-button>
								</router-link>
								<el-button icon="el-icon-search" type="primary"  @click="showSearchBtn">查询</el-button>
								<el-button @click="cancle" type="primary" icon="el-icon-refresh-right">重置</el-button>
							</div>
						</div>
					</div>
					<div class="common-page common-list">
						<el-table :data="list" class="">
							<el-table-column prop="drill_name" label="名称" align="center"></el-table-column>
							<el-table-column prop="drill_time" label="时间" align="center"></el-table-column>
							<el-table-column prop="drill_weizhi" align="center" label="演练区域"></el-table-column>
							<el-table-column prop="c_point_area" align="center" label="演练方案" v-hasPermi="['plan:drillProgramInfo:list']">
								<template slot-scope="scope">
									<router-link
										:to="{
											path: '/plan/plan-add',
											query: {
												type: 0,
												page: 0,
												id: scope.row.drill_uuid,
												c_num: cpNum,
											},
										}"
										v-hasPermi="['plan:drillProgramInfo:list']"
									>
										<el-button size="mini" type="success" plain>查看详情</el-button>
									</router-link>
								</template>
							</el-table-column>
							<el-table-column v-if="$store.state.user.userInfo.natureId == 2" prop="c_point_area" align="center" label="下发预案短信">
								<template slot-scope="scope">
									<el-button size="mini" type="primary" v-hasPermi="['plan:person:notice']" @click="sendMessage(scope.row)" plain>开始演练</el-button>
								</template>
							</el-table-column>

							<el-table-column prop="c_create_time" align="center" label="演练记录">
								<template slot-scope="scope">
									<router-link
										:to="{
											path: '/plan/plan-record',
											query: {
												id: scope.row.exercise_record_uuid,
												page: 0,
												type: 1,
												c_num: cpNum,
											},
										}"
										v-if="!(scope.row.exercise_record_uuid == null)"
									>
										<el-button size="mini" type="success" v-hasPermi="['plan:drillrecord:list']" plain>查看详情</el-button>
									</router-link>
									<el-button v-else size="mini" type="info" plain disabled>暂无数据</el-button>
								</template></el-table-column
							>

							<el-table-column label="操作" align="center" width="200px" v-if="!$store.state.userInfo.role == 0" fixed="right">
								<template slot-scope="scope">
									<el-popconfirm
										title="确定删除此项吗？"
										class="cursor"
										@onConfirm="changeStatus(scope.row, 2)"
										@confirm="changeStatus(scope.row, 2)"
										v-hasPermi="['plan:drillrecord:reove']"
									>
										<a slot="reference">
											<el-button type="danger" size="mini">删除</el-button>
										</a>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination background layout="prev, pager, next" :current-page.sync="params.page" @current-change="pageChange" :page-size="10" :total="total"></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="true">
			<el-form ref="form" :model="form" label-width="110px">
				<el-form-item label="名称" prop="login_pass">
					<el-input v-model="form.drill_name"></el-input>
				</el-form-item>
				<el-form-item label="一级分区" prop="user_phone">
					<el-select v-model="form.drill_tower" placeholder="请选择" filterable @change="changetower">
						<el-option @change="changetower($event, index)" v-for="(item, index) in units" :key="index" :label="item.tower" :value="item.tower"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="二级分区" prop="user_phone">
					<el-select v-model="form.drill_tier" placeholder="请选择" filterable>
						<el-option v-for="item in select2" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="center">
				<el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
				<el-button @click="showDia = false" type="info" plain size="small ">取消</el-button>
			</div>
		</el-dialog>
		<message v-if="$store.state.user.userInfo.natureId == 2" :type="selectUuid" ref="message" :showDia="showDia1" />
	</div>
</template>

<script>
	import unitList from "@/components/unitList";
	import message from "@/components/message.vue";

	export default {
		components: {
			unitList,
			message,
		},
		data() {
			return {
				cpNum: "",
				selectUuid: "",
				list: [],
				groups: [],
				params: {
					page: 1,
					drill_status: "0",
					drill_tower: "",
					drill_tier: "",
					drill_name: "",
					starttime: "",
					endtime: "",

					company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
				},
				form: {
					starttime: "",
					drill_tower: "",
					drill_tier: "",
					drill_name: "",
				},
				units: [],
				select2: [],
				messForm: {
					type: "",
					addr: "",
					ess: "",
					person: [],
				},
				people: [],
				total: 0, // 总数
				showDia: false, // 查询
				checkAll: false, //选择全部
				showDia1: false, // 下发短信
				searchForm: this.$getForm("safePlace"),
				editData: {},
				remoteFuncs: {},
			};
		},
		created() {
			// this.getList();
		},
		// components: { unitList },
		methods: {
			sendMessage(it) {
				log(it,55555555)
				this.selectUuid = it.drill_uuid;
				this.$refs["message"].showDia1 = true;
				log(this.showDia1, 123123);
			},
			getOne(v) {
				this.cpNum = v;
			},
			getUnit(v) {
				this.cpNum = v;
			},
			changetower(val, index) {
				this.units.map((item, index) => {
					if (item.tower === val) {
						this.select2 = item.tierList;
					}
				});
			},
			handleCheckAllChange(val) {
				this.people = val ? this.groups : [];
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.groups.length;
			},
			changeStatus(it) {
				this.$post(`drill/deljilu/${it.drill_uuid}`).then((res) => {
					this.$message({message: res.msg,type: "success", duration: 700,});
					this.getList();
				});
			},
			cancle() {
				this.params.page = 1;
				this.select2=[]
				this.resetSearch();
				this.getList();
			},

			// 生成二维码
			//  跳转添加
			link() {
				this.$route.push("/plan/drill-add");
			},

			getList() {
				this.$post("/drill/drilllist", this.params).then((res) => {
					this.list = res.data.list;
					this.total = res.data.count;
				});
			},
			getList1() {
				this.$post("/score/maintenancelist", this.params).then((res) => {
					this.list = res.data.list;
					this.count = res.count;
				});
			},
			pageChange(val) {
				this.params.page = val;
				this.getList();
			},
			searchSubmit() {
				this.params = { ...this.params, ...this.form };
				this.getList();
				this.showDia = false;

				//  打印
			},
			resetSearch() {
				this.form = {
					starttime: "",
					drill_tower: "",
					drill_tier: "",
					drill_name: "",
				};
				this.params = {
					page: 1,
					drill_status: "0",
					drill_tower: "",
					drill_tier: "",
					drill_name: "",
					starttime: "",
					endtime: "",

					company_num: this.cpNum || this.$store.state.user.company.cCompanyNum,
				};
			},
			showSearchBtn() {
				const companyNum = this.params.company_num;
				this.showDia = true;
				this.$get(`/drillplan/planJianzhu/planArea/${companyNum}`).then((res) => {
					this.units = res.data;
					console.log("🚀 ~ file: drillrecord.vue:309 ~ this.$get ~ res:", res);
				});
			},
			// getOne(val) {
			//   this.params.c_company_num = val;
			//   this.getList()
			// },
			// getUnit(val) {
			//   this.params.c_company_num = val;
			//   this.getList()

			// },
		},
		//   beforeRouteEnter(to, from, next) {
		//           console.log(from)
		//   next(vm => {
		//     if(from.name==='/plan-add'){
		//       vm.getList()
		//     }

		//   });
		// },
		watch: {
			cpNum() {
				this.params.company_num = this.cpNum;
				this.params.page = 1;

				this.getList();
			},
		},
	};
</script>

<style scoped>
	.el-dialog .el-dialog__body {
		padding: 0 !important;
	}
</style>
